import { render, staticRenderFns } from "./ingredientsBlock.vue?vue&type=template&id=e522cef2&scoped=true&"
import script from "./ingredientsBlock.vue?vue&type=script&lang=js&"
export * from "./ingredientsBlock.vue?vue&type=script&lang=js&"
import style0 from "./ingredientsBlock.vue?vue&type=style&index=0&id=e522cef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e522cef2",
  null
  
)

export default component.exports